import { render, staticRenderFns } from "./IntegralManage.vue?vue&type=template&id=75cca638&scoped=true"
import script from "./IntegralManage.vue?vue&type=script&lang=js"
export * from "./IntegralManage.vue?vue&type=script&lang=js"
import style0 from "./IntegralManage.vue?vue&type=style&index=0&id=75cca638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cca638",
  null
  
)

export default component.exports